import { Link } from 'react-router';
import { cx } from '../../../styled-system/css';
import { globalFooter } from '../../../styled-system/recipes';

export function GlobalFooter({ className }: { className?: string }) {
  const { footerLayout: footerLayoutStyle } = globalFooter();
  return (
    <div className={cx(footerLayoutStyle, className)}>
      <Menu />
      <Copyright />
    </div>
  );
}

function Menu() {
  const { menuLayout: menuLayoutStyle, textLink: textLinkStyle } = globalFooter();
  return (
    <div className={menuLayoutStyle}>
      <Link to="/terms" className={textLinkStyle}>
        利用規約
      </Link>
      {/* https://github.com/dw-zenid/zenid/issues/406
      暫定対応のためZEN ID側のプライバシーポリシー画面はコメントアウト */}
      {/* <Link to="/terms/privacy" className={textLinkStyle}>
        プライバシーポリシー
      </Link> */}
      {/* TODO: ZEN ID側でプライバシーポリシーを制定したら以下のコードを削除して上記のコードのコメントアウトを外す */}
      <a href="https://dwango.co.jp/terms/privacy" target="_blank" rel="noopener noreferrer" className={textLinkStyle}>
        プライバシーポリシー
      </a>
      <a href="https://help.zenid.jp/hc/ja" className={textLinkStyle} target="_blank" rel="noopener noreferrer">
        ヘルプ
      </a>
    </div>
  );
}

function Copyright() {
  const { copyright: copyrightStyle } = globalFooter();
  return <p className={copyrightStyle}>Copyright&nbsp;&copy;&nbsp;DWANGO&nbsp;Co.,&nbsp;Ltd.</p>;
}
